module.exports = __webpack_public_path__ + "img/offer1.4f71d5e5.png";